module.exports = __webpack_public_path__ + "static/media/ocsblended.dc8c9cf2.png";